
import { researchTemplates } from './researchTemplates';
import { aspirationTemplates } from './aspirationTemplates';
import { whereToPlayTemplates } from './whereToPlayTemplates';
import { howToWinTemplates } from './howToWinTemplates';
import { messagingTemplates } from './messagingTemplates';
import { implementationTemplates } from './implementationTemplates';

// Combine all template collections
export const playingToWinTemplates = {
  ...researchTemplates,
  ...aspirationTemplates,
  ...whereToPlayTemplates,
  ...howToWinTemplates,
  ...messagingTemplates,
  ...implementationTemplates
};

// Template population function
export function populatePlayingToWinTemplate(template: string, data: any, previousResults: any = {}): string {
  let populatedTemplate = template;
  
  // Handle previous analysis results
  if (previousResults && typeof previousResults === 'object') {
    const analysisText = Object.values(previousResults).join('\n\n');
    populatedTemplate = populatedTemplate.replace(/{previous_analysis}/g, analysisText);
  }

  // Core issue details
  if (data.core_issue_details) {
    populatedTemplate = populatedTemplate
      .replace(/{campaign_name}/g, data.core_issue_details.campaign_name || '')
      .replace(/{political_issue}/g, data.core_issue_details.political_issue || '')
      .replace(/{target_entity}/g, data.core_issue_details.target_entity || '')
      .replace(/{campaign_type}/g, data.core_issue_details.campaign_type || '')
      .replace(/{campaign_timeline}/g, data.core_issue_details.campaign_timeline || '')
      .replace(/{current_status}/g, data.core_issue_details.current_status || '');
  }
  
  // Stakeholders
  if (data.stakeholders) {
    populatedTemplate = populatedTemplate
      .replace(/{government_officials}/g, data.stakeholders.government_officials?.join(', ') || '')
      .replace(/{politicians}/g, data.stakeholders.politicians?.join(', ') || '')
      .replace(/{political_allies}/g, data.stakeholders.political_allies?.join(', ') || '')
      .replace(/{opposition_groups}/g, data.stakeholders.opposition_groups?.join(', ') || '')
      .replace(/{union_leadership}/g, data.stakeholders.union_leadership?.join(', ') || '')
      .replace(/{advocacy_groups}/g, data.stakeholders.advocacy_groups?.join(', ') || '')
      .replace(/{media_outlets}/g, data.stakeholders.media_outlets?.join(', ') || '')
      .replace(/{target_audience}/g, data.stakeholders.target_audience || '')
      .replace(/{community_context}/g, data.stakeholders.community_context || '');
  }
  
  // Political & Strategic
  if (data.political_and_strategic) {
    populatedTemplate = populatedTemplate
      .replace(/{government_motivations}/g, data.political_and_strategic.government_motivations || '')
      .replace(/{opposition_tactics}/g, data.political_and_strategic.opposition_tactics || '')
      .replace(/{political_vulnerabilities}/g, data.political_and_strategic.political_vulnerabilities || '')
      .replace(/{coalition_opportunities}/g, data.political_and_strategic.coalition_opportunities || '');
  }
  
  // Campaign Outcome
  if (data.campaign_outcome) {
    populatedTemplate = populatedTemplate
      .replace(/{winning_aspiration}/g, data.campaign_outcome.winning_aspiration || '')
      .replace(/{theory_of_change}/g, data.campaign_outcome.theory_of_change || '')
      .replace(/{required_capabilities}/g, data.campaign_outcome.required_capabilities || '');
  }
  
  return populatedTemplate;
}
